<div class="w-100">
  <div class="row w-100">
    <div class="col-md-12 footer-copyright d-flex flex-wrap align-items-center justify-content-between">
      <p class="mb-0 f-w-600">
        {{ "footer.copyright" | translate }}
      </p>
      <!-- <p class="mb-0 f-w-600">Made with Dotit srl</p> -->
    </div>
  </div>
</div>
